module.exports = __webpack_public_path__ + "static/img/kv.9ccd3ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/message/kv.png
// module id = JMqF
// module chunks = 1